const statusColors = {
  preparing: "#f59e0b",
  ready: "#10b981",
};

const geoJSONType = Object.freeze({
  Point: "Point",
  LineString: "LineString",
  Polygon: "Polygon",
  Multipoint: "Multipoint",
  MultiLineString: "MultiLineString",
  MultiPolygon: "MultiPolygon",
});

const productTypes = Object.freeze({
  main: "Comida",
  complement: "Complemento",
  beverage: "Bebida",
  combo: "Combo",
  extra: "Extra",
});

const typesUsers = Object.freeze({
  admin: {
    name: "Administrador",
    value: "admin",
  },
  client: {
    name: "Cliente",
    value: "client",
  },
  operation: {
    name: "Operador",
    value: "operation",
  },
  manager: {
    name: "Gerente",
    value: "manager",
  },
  dropoff: {
    name: "Repartidor",
    value: "dropoff",
  },
  support: {
    name: "Soporte",
    value: "support",
  },
});

const staffUserTypes = Object.freeze({
  admin: {
    name: "Administrador",
    value: "admin",
  },
  operation: {
    name: "Operador",
    value: "operation",
  },
  manager: {
    name: "Gerente",
    value: "manager",
  },
  dropoff: {
    name: "Repartidor",
    value: "dropoff",
  },
  support: {
    name: "Soporte",
    value: "support",
  },
});

const renewalOptions = Object.freeze({
  daily: {
    name: "Diariamente",
    value: "daily",
    color: "green",
  },
  weekly: {
    name: "Semanalmente",
    value: "weekly",
    color: "blue",
  },
  biweekly: {
    name: "Quincenalmente",
    value: "biweekly",
    color: "purple",
  },
  monthly: {
    name: "Mensualmente",
    value: "monthly",
    color: "orange",
  },
});

const orderStatus = Object.freeze({
  programmed: {
    value: "programmed",
    color: "#f9db16", // Yellow-?
    name: "Programada",
  },
  preparing: {
    value: "preparing",
    color: "#f97816", // Orange-?
    name: "Preparando",
  },
  prepared: {
    value: "prepared",
    color: "#3b82f6", // Blue-500
    name: "Preparada",
  },
  cancelled: {
    value: "cancelled",
    color: "#ef4444", // Red-500
    name: "Cancelada",
  },
  complete: {
    value: "complete",
    color: "#22c55e", // Green-400 (slightly lighter for visual differentiation)
    name: "Completada",
  },
  created: {
    value: "created",
    color: "#f97316", // Orange-500
    name: "Creada",
  },
});

const invoiceStatus = Object.freeze({
  valid: {
    value: "valid",
    color: "blue",
    name: "Válida",
  },
  pending: {
    value: "pending",
    color: "yellow",
    name: "Pendiente",
  },
  cancelled: {
    value: "cancelled",
    color: "red",
    name: "Cancelada",
  },
});

const paymentStatus = Object.freeze({
  paid: {
    value: "paid",
    color: "green",
    name: "Pagado",
  },
  failed: {
    value: "failed",
    color: "red",
    name: "Fallido",
  },
  refunded: {
    value: "refunded",
    color: "purple",
    name: "Reembolsado",
  },
  pending: {
    value: "pending",
    color: "orange",
    name: "Pendiente",
  },
  completed: {
    value: "completed",
    color: "blue",
    name: "Completado",
  },
});


export {
  statusColors,
  geoJSONType,
  productTypes,
  typesUsers,
  staffUserTypes,
  orderStatus,
  renewalOptions,
  invoiceStatus,
  paymentStatus,
};
